import { render, staticRenderFns } from "./weather.vue?vue&type=template&id=54d2a03b&scoped=true&"
import script from "./weather.vue?vue&type=script&lang=ts&"
export * from "./weather.vue?vue&type=script&lang=ts&"
import style0 from "./weather.vue?vue&type=style&index=0&id=54d2a03b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2a03b",
  null
  
)

export default component.exports